import { blue, Checkmark2Icon, neutral } from "@flat-ui";
import { Box } from "@mui/material";
import { memo } from "react";

interface Props {
  /** Whether the chip should have a dropdown or not */
  shouldHaveDropdown: boolean;

  /** Number of active filters in the column */
  numberOfActiveFilters: number;
}

/** Show the icon of the filter chip */
function FilterChipIconComponent({
  shouldHaveDropdown,
  numberOfActiveFilters,
}: Props): JSX.Element | undefined {
  if (numberOfActiveFilters === 0) {
    return undefined;
  }
  return shouldHaveDropdown ? (
    <Box
      component="div"
      sx={{
        width: "18px",
        height: "18px",
        backgroundColor: blue[400],
        color: neutral[0],
        textAlign: "center",
        borderRadius: "50%",
        marginRight: "6px",
      }}
    >
      <var>{numberOfActiveFilters}</var>
    </Box>
  ) : (
    <Checkmark2Icon
      style={{
        fontSize: "13px",
        color: blue[500],
        fontWeight: "bold",
      }}
    />
  );
}

export const FilterChipIcon = memo(FilterChipIconComponent);
